import { overParseJson, checkAttendantAndFetch } from '@/utils/requestUtils';

const ALERT_API_URL = 'https://afiliados.uol.com.br/api/alerts.html';
const DISABLE_ALERT_URL = 'https://afiliados.uol.com.br/api/alerts.html?idt_aff_notification=';
const HTTP_ERROR = 'HTTP_ERROR';
const storage = sessionStorage;

class AlertApi {
  static async getAlerts() {
    try {
      const fetchResponse = await checkAttendantAndFetch(ALERT_API_URL, {
        method: 'GET',
        credentials: 'same-origin',
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }
      const closedAlerts = JSON.parse(storage.getItem('closedAlerts')) || [];
      data.alertList = data.alertList && data.alertList.filter(alert => !closedAlerts.includes(alert.idt_aff_notification));
      return data.alertList;
    } catch (error) {
      throw error;
    }
  }

  static closeAlert(alertId) {
    const closedAlerts = JSON.parse(storage.getItem('closedAlerts')) || [];
    closedAlerts.push(alertId);
    storage.setItem('closedAlerts', JSON.stringify(closedAlerts));
  }

  static async disableAlert(idtAlert) {
    try {
      const fetchResponse = await checkAttendantAndFetch(DISABLE_ALERT_URL + idtAlert, {
        method: 'GET',
        credentials: 'same-origin',
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default AlertApi;
